export const SESSION_ID = 'session-id';
export const NEXT = 'next';